/**
 * <navera-delivery-estimate data-min="5" data-max="7" data-saturday="false">
 *
 * Replaces its server-rendered fallback ("in 5–7 working days") with a date range counted from today
 * in working days: "by Fri 23 – Tue 27 Oct". Sundays never count; Saturdays count only when
 * data-saturday is "true". Used by blocks/navera-trust-badges.liquid.
 *
 * The date goes into a shadow root, so when Horizon morphs the product section on a variant change
 * (light DOM only) it can't put the fallback text back.
 */
const WEEKDAY = new Intl.DateTimeFormat('en-IN', { weekday: 'short' });
const MONTH = new Intl.DateTimeFormat('en-IN', { month: 'short' });

/** @param {Date} from @param {number} days @param {boolean} countSaturday */
function addWorkingDays(from, days, countSaturday) {
  const date = new Date(from);
  let left = days;
  while (left > 0) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && (day !== 6 || countSaturday)) left -= 1;
  }
  return date;
}

/** "Fri 23" (plus " Oct" when asked) */
function formatDay(date, withMonth) {
  const text = `${WEEKDAY.format(date)} ${date.getDate()}`;
  return withMonth ? `${text} ${MONTH.format(date)}` : text;
}

class NaveraDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const min = Number(this.dataset.min);
    const max = Math.max(min, Number(this.dataset.max));
    if (!Number.isFinite(min) || min < 1) return;

    const countSaturday = this.dataset.saturday === 'true';
    const today = new Date();
    const first = addWorkingDays(today, min, countSaturday);
    const last = addWorkingDays(today, max, countSaturday);

    let text;
    if (min === max) {
      text = `by ${formatDay(last, true)}`;
    } else if (first.getMonth() === last.getMonth()) {
      text = `by ${formatDay(first, false)} – ${formatDay(last, true)}`;
    } else {
      text = `by ${formatDay(first, true)} – ${formatDay(last, true)}`;
    }

    const root = this.shadowRoot ?? this.attachShadow({ mode: 'open' });
    root.textContent = text;
  }
}

if (!customElements.get('navera-delivery-estimate')) {
  customElements.define('navera-delivery-estimate', NaveraDeliveryEstimate);
}
